<template>
  <v-row>
    <v-col cols="12">     
      <v-divider></v-divider>
      <v-toolbar flat dense :color="color">
        <multiple-switch
          v-if="form.type === 'likert'"
          v-model="form.isAskComment"
          :label="likertAnswerLabel"
          class="mr-5"
        ></multiple-switch>
        <multiple-switch
          v-if="form.type === 'choice'"
          v-model="form.isMultipleAnswer"
          :label="multipleAnswerLabel"
        ></multiple-switch>
        <v-spacer v-if="form.type === 'choice'"></v-spacer>
        <multiple-switch
          v-model="form.isMandatory"
          :label='$t("poll.lblMandatoryResponse")'
        ></multiple-switch>
        <v-spacer></v-spacer>
        <v-menu
          v-model="settingMenu"
          bottom
          offset-y
          :menu-props="{ bottom: true, offsetY: true }"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip bottom :disabled="hideTooltip">
              <template v-slot:activator="{ on: tooltip }">
                <v-icon v-bind="attrs" v-on="{ ...tooltip, ...menu }"
                  >mdi-dots-horizontal</v-icon
                >
              </template>
              <span>{{ $t("poll.lblSettings") }}</span>
            </v-tooltip>
          </template>

          <v-list dense>
            <v-list-item active-class="primary--text" @click="form.isSubtitle = !form.isSubtitle">
              <v-list-item-action class="ma-0 pd-0">
                <v-icon small v-if="form.isSubtitle">mdi-check</v-icon>
                <v-icon small v-else>mdi-blank</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> {{subtitleLabel}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
    </v-col>
  </v-row>
</template>

<script>
import MultipleSwitch from "./MultipleSwitch.vue";
export default {
  components: { MultipleSwitch },
  name: "QuestionSettings",
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    color:{
      type: String,
      default:"",
    },
  },
  data() {
    return {
      hideTooltip: false,
      settingMenu: false,
      mandatoryLabel: this.$t("poll.lblMandatoryResponse"),
      question: this.value,
    };
  },
  watch: {
    settingMenu(value) {
      if(value) {
        this.hideTooltip = true;
      }
      else {
        this.hideTooltip = false;
      }
    }
  },
  computed: {
    form: {
      get() {
        return this.question;
      },
      set(value) {
        this.question = value;
        this.$emit("input", value);
      },
    },
    multipleAnswerLabel() {
      return this.$t("poll.lblMultipleAnswer");
    },
    likertAnswerLabel() {
      return this.$t("poll.likertAnswerLabel");
    },
     subtitleLabel() {
      return this.$t("poll.lblSubtitle");
    },
     textLabel() {
      return this.$t("poll.lblLabel");
    },
  },

};
</script>

<style scoped>
.number-style {
  display: inline-grid !important;
  font-size: 14px !important;
  margin-right: 5px;
}
</style>